import { render, staticRenderFns } from "./home-3.vue?vue&type=template&id=1f991211&"
import script from "./home-3.vue?vue&type=script&lang=js&"
export * from "./home-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports